<template>
    <div class="field">
        <p class="control has-icons-left">
            <input
                :class="[{ 'is-danger': errors.has($attrs['data-vv-name']) }, 'input']"
                maxlength="23"
                placeholder="0000 0000 0000 0000"
                v-bind="$attrs"
                v-validate="'required|cardNumber'"
                ref="input"
                @input="handleInputChange"
            />
            <span class="icon is-small is-left">
                <i class="far fa-credit-card"></i>
            </span>
        </p>
    </div>
</template>

<script>
export default {
    name: 'card-number',
    inject: ['$validator'],
    props: {
        inputValue: { required: true, default: '' }
    },
    data: () => ({ value: null, displayValue: null }),
    created() {
        this.$validator.extend('cardNumber', {
            getMessage: () => this.$t('payment system.validation.card number.format'),
            validate: () => this.validate()
        });
    },
    methods: {
        handleInputChange() {
            this.value = this.$refs.input.value.replace(/\D/g, '');
            this.$refs.input.value = this.value
                .split(/(.{4})/)
                .filter(item => item)
                .join(' ');
            this.$emit('update:inputValue', this.value);
        },
        validate() {
            let flag = true;
            let sum = 0;
            const digits = (this.value + '').split('').reverse();
            for (let i = 0, len = digits.length; i < len; i++) {
                let digit = parseInt(digits[i], 10);
                (flag = !flag) && (digit *= 2);
                digit > 9 && (digit -= 9);
                sum += digit;
            }

            return sum % 10 === 0;
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/payments/card-number.vue